import { FormattedMessage } from "react-intl";
import CustomSelect from "../CustomSelect";
import { AgeGroups } from "~enums/ageGroups";

const options = Object.values(AgeGroups).map((value) => ({ value, label: <FormattedMessage id={`ageGroup.${value}`} /> }));

type Props = {
  className?: string;
  disabled?: boolean;
  onChange?: (value: string) => void;
  value?: string | null;
}

const SelectAgeGroup = ({ className, disabled, onChange, value }: Props) => (
  <CustomSelect
    style={{ minWidth: "130px" }}
    value={value}
    onChange={(value) => onChange?.(value as string)}
    options={options}
    placeholder={<FormattedMessage id="ageGroup" />}
    allowClear
    className={className}
    disabled={disabled}
  />
);

export default SelectAgeGroup;
